/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { Badge } from '@material-ui/core';

import OutsideClickHandler from 'react-outside-click-handler';

import Icon from '../../Icons';
import CardTooltip from '../../CardTooltip';
import Input from '../Input';
import Checkbox from '../Checkbox';

import * as S from './styles';
import * as Styles from '../styles';
import { cloneObject } from '../../../utils';
import { CustomIconButton } from '../../../styles/styles';
import { useGlobal } from '../../../contexts/Global/context';

function sortList(list = [], sortByKey) {
    const clonedList = cloneObject(list);

    if (!clonedList.length) return null

    return clonedList?.sort((a, b) => {
        if (a[sortByKey] === b[sortByKey]) return 0;
        if (a[sortByKey] < b[sortByKey]) return -1;
        if (a[sortByKey] > b[sortByKey]) return 1;

        return 1;
    });
}

function NovoSelect({ field, multiple, onChange, onBlur, hasDefaultOption = true, sortByKey = 'nome' }) {
    field.options = sortList(field.options, sortByKey);

    const limitToShowSearchInput = 10;

    const containerRef = useRef(null);
    const optionsRef = useRef(null);

    const [isOnFocus, setIsOnFocus] = useState(undefined);
    const [optionsPosition, setOptionsPosition] = useState(0);
    const { contrastTheme } = useGlobal();
    const [dataChanged, setDataChanged] = useState({
        id: field.id,
        value: field.value,
        lookup: field.lookup,
    });
    const [selectedOptions, setSelectedOptions] = useState(
        multiple ? field.value || [] : field.value !== false ? [field.value] : []
    );

    const [searchField, setSearchField] = useState({
        id: `searchOptions-${new Date()}`,
        label: '',
        value: '',
        icon: { name: 'search', type: 'round', size: 14 },
    });

    let colorArrowIcon = field.error ? (contrastTheme ? '#FFF333' : '#EC130F') : contrastTheme ? '#FFF333' : '#EC6E0C';

    if (field.disabled) colorArrowIcon = contrastTheme ? '#FFFF' : '#5B5B5F';

    if (!field.options) field.options = [];

    if (!field.placeholder && hasDefaultOption) field.placeholder = 'Selecione';

    useEffect(() => {
        document.querySelector('#page-content').style.overflow = isOnFocus ? 'hidden' : 'overlay';

        if (isOnFocus === false && typeof onBlur === 'function') {
            onBlur({ target: dataChanged });
        }
    }, [isOnFocus]);

    useEffect(() => {
        setSelectedOptions(multiple ? field.value || [] : field.value !== false ? [field.value] : []);

        setDataChanged({ id: field.id, value: field.value, lookup: field.lookup });
    }, [field.value]);

    function calculateOptionsPosition() {
        const containerSize = 43;

        const elementPositionY = containerRef.current.getBoundingClientRect().y;

        const screenHeight = document.body.offsetHeight;

        // Deixar visivel para pegar altura do bloco de opcoes
        optionsRef.current.style.display = 'block';

        const optionsHeight = optionsRef.current.offsetHeight;

        optionsRef.current.scrollTo(0, 0);

        optionsRef.current.style = {};

        const avaiableSpace = screenHeight - elementPositionY - containerSize;

        if (avaiableSpace > optionsHeight) {
            // retorna o tamanho normal do container
            return containerSize;
        }

        // retorna o quanto o elemento deve subir
        return screenHeight - elementPositionY - optionsHeight - containerSize;
    }

    function getOnlyCheckeds(selectedValues) {
        if (!selectedValues || selectedValues.length < 0) {
            selectedValues = selectedOptions.map((value) => value?.toString());
        }

        return field.options.filter(({ codigo }) => selectedValues.includes(codigo?.toString()));
    }

    function onClickSelect(event) {
        if (field.disabled) return;

        const allowedIdsToClick = ['container-select', 'select-icon', 'select-value', 'select-placeholder'];

        if (allowedIdsToClick.some((id) => event.target.id.includes(id))) {
            const position = calculateOptionsPosition();

            setOptionsPosition(position);

            setIsOnFocus(!isOnFocus);
        }
    }

    function onSelectOption({ code, name, checked, ...rest }) {
        const data = {
            id: field.id,
            value: code?.toString(),
            clickedOption: { code, name },
            lookup: name,
            isChecked: !checked,
            ...rest,
        };

        setDataChanged(data);

        let filtered = selectedOptions;

        if (checked) {
            filtered = selectedOptions.filter((value) => value !== code).map((value) => value?.toString());
        }

        if (!checked) {
            filtered.push(code);
        }

        if (multiple) data.value = filtered;

        if (typeof onChange === 'function') onChange(data);

        if (code === undefined) {
            setSelectedOptions([]);

            setIsOnFocus(false);

            return;
        }

        if (!multiple) {
            setSelectedOptions([code]);

            setIsOnFocus(false);

            return;
        }

        setSelectedOptions(filtered);
    }

    function handleFilterOptions(event) {
        if (field.disabled) return;

        const { value } = event;

        setSearchField({
            ...searchField,
            value,
        });
    }

    function focusSearchInput() {
        optionsRef.current.querySelector('input').focus();
    }

    function getFirstChild() {
        const { lastChild: ul } = optionsRef.current;
        const { firstChild } = ul;

        return firstChild;
    }

    function getLastChild() {
        const { lastChild: ul } = optionsRef.current;
        const { lastChild } = ul;

        return lastChild;
    }

    function isFirstChildOptions(actualId) {
        return actualId === getFirstChild().id;
    }

    function isLastChildOptions(actualId) {
        return actualId === getLastChild().id;
    }

    function handleBlurLastOption({ target }) {
        // Caso esteja saindo do ultimo filho, fecha o select
        if (isLastChildOptions(target.id)) {
            setIsOnFocus(false);
        }
    }

    function handleKeyPressOption({ event, dataOption }) {
        const $element = event.target;

        if ($element.tagName === 'LI' && ['Space', 'Enter'].includes(event.code)) {
            onSelectOption(dataOption);

            return;
        }

        switch (event.code) {
            case 'ArrowUp':
                if (field.options.length > limitToShowSearchInput && isFirstChildOptions(event.target.id)) {
                    focusSearchInput();
                    break;
                }

                if ($element.previousElementSibling) {
                    $element.previousElementSibling.focus();
                }

                break;

            case 'ArrowDown':
                if ($element.tagName === 'INPUT') {
                    getFirstChild().focus();
                    break;
                }

                if ($element.nextElementSibling) $element.nextElementSibling.focus();
                break;

            case 'Tab':
                if (isLastChildOptions(event.target.id)) {
                    handleBlurLastOption(event);
                }
                break;

            case 'Escape':
                setIsOnFocus(false);
                break;

            default:
                break;
        }
    }

    function handleFocusCustomIcon() {
        const position = calculateOptionsPosition();

        setOptionsPosition(position);

        setIsOnFocus(true);

        setTimeout(() => {
            if (field.options.length > limitToShowSearchInput) {
                focusSearchInput();

                return;
            }

            getFirstChild().focus();
        }, 1);
    }

    return (
        <Styles.FormGroup className="form-control_select">
            <label>
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                {field.help && (
                    <CardTooltip message={field.help}>
                        <Styles.ContainerHelp>
                            <Icon name="info" size={18} />
                        </Styles.ContainerHelp>
                    </CardTooltip>
                )}
            </label>

            <OutsideClickHandler
                onOutsideClick={() => {
                    if (isOnFocus) {
                        setIsOnFocus(false);
                    }
                }}
            >
                <S.Container
                    id={`${field.id}_container-select`}
                    disabled={field.disabled}
                    className={`container-select ${field.error ? 'error' : ' '} ${field.disabled ? 'disabled' : ' '}`}
                    isOnFocus={isOnFocus}
                    onClick={onClickSelect}
                    ref={containerRef}
                >
                    <div id={`${field.id}_select-value`}>
                        {getOnlyCheckeds().length > 0 ? (
                            getOnlyCheckeds()
                                .map(({ nome }) => nome)
                                ?.join(', ')
                        ) : (
                            <span id="select-placeholder" className="placeholder">
                                <S.SelectText>{field.placeholder}</S.SelectText>
                            </span>
                        )}
                    </div>

                    <CustomIconButton
                        type="button"
                        id={`${field.id}_select-icon`}
                        disabled={field.disabled}
                        isOnFocus={isOnFocus}
                        onClick={handleFocusCustomIcon}
                    >
                        <Icon name="ArrowDown" color={colorArrowIcon} />
                    </CustomIconButton>

                    {multiple && (
                        <Badge badgeContent={<S.BagdeText>{getOnlyCheckeds().length}</S.BagdeText>} color="primary" />
                    )}

                    <Styles.ContainerOptions isOnFocus={isOnFocus} optionsPosition={optionsPosition} ref={optionsRef}>
                        {field.options.length > limitToShowSearchInput && (
                            <Input
                                field={searchField}
                                onKeyDown={(event) => handleKeyPressOption({ event })}
                                onChange={handleFilterOptions}
                            />
                        )}

                        <ul>
                            {!multiple && hasDefaultOption && (
                                <li
                                    id={`${field.id}_placeholder`}
                                    onKeyDown={(event) =>
                                        handleKeyPressOption({
                                            event,
                                            dataOption: { code: undefined, name: field.placeholder },
                                        })
                                    }
                                    tabIndex={0}
                                    onClick={() => onSelectOption({ code: undefined, name: field.placeholder })}
                                >
                                    <S.SelectText>
                                        <span>{field.placeholder}</span>
                                    </S.SelectText>
                                </li>
                            )}

                            {field.options.length === 0 && (
                                <li className="no-data-found">
                                    <S.SelectText>
                                        <span>Nenhuma opção encontrada...</span>
                                    </S.SelectText>
                                </li>
                            )}

                            {field.options
                                .filter(
                                    ({ nome }) =>
                                        nome?.toLowerCase().includes(searchField?.value?.toLowerCase()) ||
                                        !searchField.value
                                )
                                .map(({ codigo, nome, ...rest }) => {
                                    const checked = selectedOptions.includes(codigo);

                                    const dataOption = { code: codigo, name: nome, checked, ...rest };

                                    return (
                                        <li
                                            key={`${field.id}_${codigo}`}
                                            id={`${field.id}_${codigo}`}
                                            onKeyDown={(event) => handleKeyPressOption({ event, dataOption })}
                                            tabIndex={0}
                                            data-selected={checked ? 'true' : ''}
                                            onClick={() => onSelectOption(dataOption)}
                                        >
                                            {multiple && <Checkbox checked={checked} />}
                                            <S.SelectText>
                                                <span>{nome}</span>
                                            </S.SelectText>
                                        </li>
                                    );
                                })}
                        </ul>
                    </Styles.ContainerOptions>
                </S.Container>
            </OutsideClickHandler>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default NovoSelect;
